/* Carosello loghi — Bangerang Network
   Scorre da solo, si ferma al passaggio del mouse, e si puo' trascinare
   con il mouse o con il dito. Il ciclo e' continuo: la pista e' duplicata
   e quando il primo giro finisce la posizione rientra senza stacco. */
(function () {
  'use strict';

  var RIDOTTO = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function avvia(scroller) {
    if (scroller.dataset.bnPronto) return;
    scroller.dataset.bnPronto = '1';

    var inner = scroller.querySelector('.bn-marquee__inner');
    if (!inner) return;

    var durata = parseFloat(scroller.getAttribute('data-durata')) || 60;
    var meta = 0, velocita = 0;

    function misura() {
      meta = inner.scrollWidth / 2;
      velocita = meta > 0 ? meta / durata : 0;   // pixel al secondo
    }
    misura();
    window.addEventListener('resize', misura);

    var fermo = false, trascina = false, partenzaX = 0, partenzaScroll = 0, mosso = 0;
    var ultimo = null;

    function passo(ora) {
      if (ultimo === null) ultimo = ora;
      var dt = (ora - ultimo) / 1000;
      ultimo = ora;

      if (!fermo && !trascina && velocita > 0) {
        scroller.scrollLeft += velocita * dt;
      }
      // rientro continuo, in entrambe le direzioni
      if (meta > 0) {
        if (scroller.scrollLeft >= meta) scroller.scrollLeft -= meta;
        else if (scroller.scrollLeft < 0) scroller.scrollLeft += meta;
      }
      requestAnimationFrame(passo);
    }
    if (!RIDOTTO) requestAnimationFrame(passo);

    scroller.addEventListener('mouseenter', function () { fermo = true; });
    scroller.addEventListener('mouseleave', function () { fermo = false; });

    scroller.addEventListener('pointerdown', function (e) {
      trascina = true; mosso = 0;
      partenzaX = e.clientX;
      partenzaScroll = scroller.scrollLeft;
      scroller.classList.add('is-trascinando');
      scroller.setPointerCapture(e.pointerId);
    });

    scroller.addEventListener('pointermove', function (e) {
      if (!trascina) return;
      var d = e.clientX - partenzaX;
      mosso = Math.max(mosso, Math.abs(d));
      scroller.scrollLeft = partenzaScroll - d;
    });

    function fine(e) {
      if (!trascina) return;
      trascina = false;
      scroller.classList.remove('is-trascinando');
      try { scroller.releasePointerCapture(e.pointerId); } catch (err) {}
    }
    scroller.addEventListener('pointerup', fine);
    scroller.addEventListener('pointercancel', fine);

    /* Un trascinamento non deve aprire il link del logo su cui si e' partiti */
    scroller.addEventListener('click', function (e) {
      if (mosso > 6) { e.preventDefault(); e.stopPropagation(); }
    }, true);

    scroller.addEventListener('dragstart', function (e) { e.preventDefault(); });
  }

  function init(radice) {
    (radice || document).querySelectorAll('.bn-marquee').forEach(avvia);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else { init(); }

  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
